import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { I18nModule } from '@spartacus/core'
import { ProductGridPriceComponent } from './product-grid-price.component'

@NgModule({
  declarations: [
    ProductGridPriceComponent
  ],
  imports: [
    CommonModule,
    I18nModule
  ],
  exports: [
    ProductGridPriceComponent
  ]
})
export class ProductGridPriceModule { }
